module.exports = __webpack_public_path__ + "img/Onboarding.c284d103.svg";